import getCsrfToken from './csrf_token'
import { ww } from 'bits/global'
import { captureMessage } from 'bits/error_tracker'
import { currentUrl } from 'bits/location'
//dependency
const $ = window.jQuery

$(document).ajaxSend((event, xhr, settings) => {
  if (settings.type != 'GET') {
    xhr.setRequestHeader('X-CSRF-Token', getCsrfToken())
  }
  if (ww.uid) {
    xhr.setRequestHeader('X-UID', ww.uid)
  } else {
    const context = { location: currentUrl() }
    captureMessage('No UID set for brahms', { context })
  }
})

export default $.ajax
